
import {
  Vue, Component, Ref, Prop,
} from 'vue-property-decorator'
import Widget from '@/components/Widget/Widget.vue'
import ViewModel from '@/models/ViewModel'
import IconAction from '@/components/IconAction/IconAction.vue'
import SearchInput from '@/components/SearchInput/SearchInput.vue'
import DataTable from '@/components/DataTable/index.vue'
import { getModule } from 'vuex-module-decorators'
import SystemtModule from '@/store/SystemModule'
import RowToggle from '@/components/RowToggle/RowToggle.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import CheckboxInput from '@/components/CheckboxInput/index.vue'
import MediaProperty from '@/models/MediaProperty'
import TenantSharedModel from '@/models/TenantSharedModel'
import MediaPackage from '@/models/MediaPackage'
import fields from './share_fields'

@Component({
  components: {
    Widget,
    IconAction,
    SearchInput,
    DataTable,
    RowToggle,
    FormInput,
    CheckboxInput,
  },
})
export default class ShareMediaPackageHome extends ViewModel {
  @Ref() readonly dataTable!: HTMLFormElement

  @Prop()
  public model_id!: string

  public model: MediaPackage = new MediaPackage()

  public records: number = 0

  public loading: boolean = false

  public ready = false

  public query: string[] = []

  public selected: string[] = []

  public logos: string[] = []

  public fieldFilters: any = {}

  public fields: Array<any> = []

  public get show_fields() {
    return this.fields.filter((f: any) => f.show)
  }

  public get options() {
    return {}
  }

  public rows(context: any) {
    this.loading = true
    const field_filters = Object.keys(this.fieldFilters)
      .filter((key: string) => this.fieldFilters[key] !== '')
      .map((key: string) => `${key}:${this.fieldFilters[key].toLowerCase()}`)
    this.syncFilters()
    return TenantSharedModel.paginate({
      page_size: context.perPage,
      page: context.currentPage,
      order_by: context.sortBy,
      order: context.sortDesc ? 'desc' : 'asc',
      query: [...context.filter, ...field_filters],
      // @ts-ignore
      model_type: 'MediaPackage',
      model_id: this.model.id,
    }).then(result => {
      this.records = result.records
      this.loading = false
      return result.data
    })
  }

  public editShare(model: TenantSharedModel) {
    this.$router.push(`/app/sales/media_package/${model.model_id}/share/${model.id}`)
  }

  public refresh() {
    this.dataTable.refresh()
  }

  public resetFilters() {
    this.fieldFilters = {}
    this.query = []
    this.clearFilters()
    this.refresh()
  }

  public init() {
    this.loading = true
    const { query } = this.$route
    if (this.model_id) {
      MediaPackage.find(this.model_id).then(media_package => {
        if (media_package instanceof MediaPackage) {
          this.model = media_package
          this.loading = false
        }
        this.ready = true
      })
    } else {
      this.loading = false
      this.ready = true
    }
  }

  public created() {
    this.init()
  }

  public mounted() {
    this.fields = fields
    this.loadFilters()
  }

  public syncFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'share_media_package',
      data: { query: this.query, fieldFilters: this.fieldFilters },
    })
  }

  public loadFilters() {
    const system = getModule(SystemtModule)
    system.getFilter('share_media_package').then((filter: any) => {
      if (filter) {
        this.query = filter.query
        this.fieldFilters = filter.fieldFilters
      }
    })
  }

  public clearFilters() {
    const system = getModule(SystemtModule)
    system.updateState({
      name: 'filters',
      type: 'share_media_package',
      data: null,
    })
  }

  public shareModel() {
    this.$router.push(`/app/sales/media_package/${this.model.id}/share`)
  }

  // this.$router.push(`/app/media_package/${this.model.id}/share/`)
}
